import * as React from 'react'
import { Form, Field, InjectedFormProps } from 'redux-form'
import { vRequired } from 'components/Input/Input.validations'
import Button from 'components/Button'
import { dispatchToProps } from './ContactImport.container'
import { IContactBase } from 'features/Contacts/types'
import cn from 'classnames'
import * as sMarg from 'styles/modules/margins.scss'
import * as sLay from 'styles/modules/layout.scss'
import * as sText from 'components/Text/Text.scss'
import { Textarea } from 'components/Input/Textarea'
import { csvToContacts } from '../utils'

export interface IContactImportProps extends InjectedFormProps<IContactBase> {
  push: typeof dispatchToProps['push']
  importContacts: typeof dispatchToProps['importContacts']
  onAfterSubmit: () => undefined
}

export class ContactImportComponent extends React.Component<IContactImportProps> {
  downloadCsvDemo = () => {
    const headers = [
      'userId',
      'firstName',
      'lastName',
      'company',
      'email',
      'phoneNumbers[0]',
      'phoneNumbers[1]',
      'customFields.example',
    ].join(',')
    const example = [
      'your-internal-user-or-crm-id',
      'Joe',
      'Blogs',
      'Company Name',
      'some@email.com',
      '+61404123456',
      '+61404123456',
      'enter any custom data',
    ].join(',')
    const data = [headers, example].join('\r\n')
    return `data:application/csv;charset=utf-8,${encodeURIComponent(data)}`
  }
  render() {
    const { submitting, handleSubmit, importContacts, push, onAfterSubmit } = this.props
    const submit = data =>
      importContacts(csvToContacts(data.data))
        .then(({ value: { data } }) => {
          if (data[0]) {
            push(`/dashboard/contacts/${data[0].id}`)
          }
        })
        .then(onAfterSubmit)

    return (
      <Form onSubmit={handleSubmit(submit as any)}>
        <div className={cn(sText.descrip4, sText.center, sMarg.mb30)}>
          Please transform your user or CRM data into our{' '}
          <a
            style={{ textDecoration: 'underline' }}
            download="contacts-import.csv"
            href={this.downloadCsvDemo()}
            target="_blank"
          >
            CSV Format
          </a>
          .
          <br />
          After creating your CSV, open it as a text file and paste it below.
        </div>
        <Field
          name="data"
          label="Paste CSV Data"
          display="standard"
          style={{ whiteSpace: 'pre', maxHeight: '300px' }}
          component={Textarea}
          validate={[vRequired]}
        />
        <div className={cn(sText.descrip4, sText.center, sMarg.mt30)}>
          If existing contacts are found with the same 'phoneNumber', these will be merged.
        </div>
        <div className={cn(sLay['layout-column'], sLay['layout-align-center-center'], sMarg.mt30)}>
          <Button color="tertiary" loading={submitting} type="submit">
            Parse and Import
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Contacts/ContactImport/ContactImport.tsx